/**
 * Created by andrey on 10.01.18.
 */

const Notifications = function () {
    ConnectorEventEmitter.call(this);

    this.queue = {};

    this.onInitCallbacks = [];
    this.initialized = false;
    this.permitted = false;
};

Notifications.prototype = Object.create(ConnectorEventEmitter.prototype);
Notifications.prototype.constructor = Notifications;

Notifications.prototype.initialize = function () {
    this.initialized = true;

    this.initSender();
    this.load();

    connector.platform.subscribeNative("LocalPushes", this.onNativeEvent.bind(this));

    this.onInitCallbacks.forEach((callback) => callback());
    this.onInitCallbacks = [];

    if (connector.config.debugMode) {
        Notifications.TIMEOUT_THRESHOLD = connector.utils.parseInterval("10 seconds");
    }
};

Notifications.prototype.processQueue = function () {
    const queue = this.queue;
    for (const id in queue) {
        const { timeout, push } = queue[id];
        if (push) {
            this.send(push, timeout);
        }
    }

    this.queue = {};
};

Notifications.prototype.askPermission = function (f) {
    if (!this.initialized) {
        this.onInitCallbacks.push(this.askPermission.bind(this, f));
        return;
    }

    if (!this.sender) {
        f();
        return;
    }

    const options = {};
    if (this.requestTime + Notifications.REQUEST_INTERVAL < Date.now()) {
        this.requestTime = Date.now();
        this.save();

        options.withRequest = true;
    }

    this.sender.askPermissions(options, (code, permitted) => {
        if (code === connector.CODE_SUCCEED) {
            this.setPermitted(permitted);
        }

        if (this.permitted) {
            this.processQueue();
        }

        f();
    });
};

Notifications.prototype.isPermitted = function () {
    return this.permitted;
};

Notifications.prototype.setPermitted = function (permitted) {
    if (this.permitted !== permitted) {
        this.permitted = permitted;
        this.save();
    }
};

Notifications.prototype.initSender = function () {
    const classes = [MicrosoftSender, MSStartSender, WebViewSender, SocialSender];

    if (typeof FakeSender !== "undefined") {
        classes.push(FakeSender);
    }

    for (let i = 0; i < classes.length; i++) {
        if (classes[i].isAppropriate()) {
            this.sender = new classes[i]();

            break;
        }
    }

    if (this.sender) {
        this.maxTimeout = connector.utils.parseInterval(`${this.sender.config.maxTimeout + 1} days`);
    }
};

Notifications.prototype.cancelAll = function () {
    for (const id in this.plannedPushes) {
        this.cancel(id);
    }
};

Notifications.prototype.load = function () {
    let data = connector.dataLoader.load(SimpleDataLoader.TYPES.PUSHES) || {};
    this.permitted = data.permitted;
    this.requestTime = data.requestTime || 0;

    data = connector.utils.clone(data);
    delete data.permitted;
    delete data.requestTime;

    for (const pushId in data) {
        if (!data[pushId].push) {
            delete data[pushId];
        }
    }

    this.plannedPushes = data;
};

Notifications.prototype.save = function () {
    const data = connector.utils.clone(this.plannedPushes);
    data.permitted = this.permitted;
    data.requestTime = this.requestTime;
    connector.dataLoader.save(SimpleDataLoader.TYPES.PUSHES, data);
};

Notifications.prototype.send = function (push, timeout) {
    if (!this.sender) {
        return;
    }

    const id = push.id;
    if (connector.platform.oneOf(connector.MSSTART) && id > MSStartSender.ID_LIMIT && push.msstartId === undefined) {
        return;
    }

    if (!this.permitted) {
        this.queue[id] = {
            timeout,
            push
        };
        return;
    }

    timeout = timeout || 0;
    const curValue = this.plannedPushes[id] ? this.plannedPushes[id].when : 0;
    const nextValue = timeout ? Date.now() + timeout : 0;

    if (Math.abs(curValue - nextValue) < Notifications.ONE_MINUTE || this.maxTimeout <= timeout) {
        return;
    }

    if (timeout < Notifications.TIMEOUT_THRESHOLD) {
        if (curValue) {
            this.cancel(id);
        }
    } else {
        const pushData = {
            when: nextValue,
            push
        };

        if (this.sender.send(push, timeout)) {
            this.plannedPushes[id] = pushData;
            this.save();
        }
    }
};

Notifications.prototype.cancel = function (id) {
    if (!this.sender) {
        return;
    }
    delete this.queue[id];

    if (!this.plannedPushes[id]) {
        return;
    }

    const push = this.plannedPushes[id].push;

    if (this.plannedPushes[id].when) {
        if (this.plannedPushes[id].when > Date.now()) {
            this.sender.cancel(push);
        } else {
            this.trigger("pushSent", push);
        }
    }
    
    delete this.plannedPushes[id];
    this.save();
};

Notifications.prototype.isClientSender = function () {
    return connector.platform.oneOf(
        connector.RUSTORE,
        connector.AMAZON,
        connector.ANDROID,
        connector.DIGITAL,
        connector.IOS,
        connector.MACOS,
        connector.MSSTART,
        connector.MICROSOFT,
        connector.G5WINDOWS,
        connector.MSIX
    );
};

Notifications.prototype.onNativeEvent = function (event, options) {
    console.log(`LocalPushes.onNativeEvent - ${event}`);

    switch (event) {
        case "clickEvent":
            this.trigger("pushClicked", options.code);
            break;
    }
};

Notifications.ONE_MINUTE = connector.utils.parseInterval("1 minute");
Notifications.TIMEOUT_THRESHOLD = connector.utils.parseInterval("3 minutes");
Notifications.REQUEST_INTERVAL = connector.utils.parseInterval("7 days");

connector.notifications = new Notifications();